import { localized } from '@/i18n/localize'

// Hindi comes from the mobile ARB (`npm run i18n:build`); sentences new in LP-491 stay English until the app adds them.
export const viewCountryStrings = localized({
  country: 'Country',
  countrySubtitle: 'Your dashboard shows figures for this country',
  countryPicker: 'Choose a country',
  allCountries: 'All countries',
  all: 'All',
  switchLabel: (name: string) => `Country: ${name}`,
  switched: (name: string) => `Now showing ${name}`,
  switchTo: (name: string) => `Switch to ${name}`,
  totalsPerCountry: 'Totals are shown for one country at a time. Pick a country to see them.',
  propertyElsewhere: (name: string) => `This property is in ${name}. It will be listed under ${name}.`,
  somethingWentWrong: 'Something went wrong',
  close: 'Close',
})
